import * as yup from 'yup'
import { CompanyFormProfile } from './company-form.profile'

export const schema = (): yup.ObjectSchema<CompanyFormProfile> =>
  yup.object({
    id: yup.number().optional(),
    shortName: yup.string().label('Short name').emptyAsUndefined().required(),
    name: yup.string().label('Name').emptyAsUndefined().required(),
    alternativeNames: yup.array().label('Alternative name').required(),
    companyTypes: yup.array().label('Company types').required().min(1),
    taxId: yup.string().label('Tax ID').emptyAsUndefined().nullable(),
    phoneNumber: yup.string().label('Phone number').emptyAsUndefined().nullable(),
    email: yup.string().label('Email').email().emptyAsUndefined().nullable(),
    remarks: yup.string().label('Remarks').emptyAsUndefined().nullable(),
    isDeactivated: yup.boolean().label('Deactivated').required(),
    addressLine1: yup.string().label('Address line 1').emptyAsUndefined().nullable(),
    addressLine2: yup.string().label('Address line 2').emptyAsUndefined().nullable(),
    city: yup.string().label('City').emptyAsUndefined().nullable(),
    postalCode: yup.string().label('Postal code').max(10).emptyAsUndefined().nullable(),
    country: yup.string().label('Country').emptyAsUndefined().nullable(),
    accountInfo: yup.string().label('Account info').emptyAsUndefined().nullable(),
  })
